import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import product4 from "../assets/products/product4.png";

export default function Refund() {
  //   const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full flex flex-col items-center">
      <div className="w-full max-w-screen-2xl bg-white shadow-xl pb-5 rounded-2xl relative">
        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="absolute top-20 left-10 p-2 text-black bg-white cursor-pointer rounded-full shadow-md transition-all duration-300 ease-in-out hover:scale-110 hover:bg-purple-100 hover:text-purple-700"
        >
          <ArrowLeft
            size={25}
            className="transition-transform duration-300 ease-in-out group-hover:-translate-x-1"
          />
        </button>

        {/* Product Info */}
        <div className="text-center bg-gradient-to-t from-white to-pink-700/50">
          <img
            loading="lazy"
            src={product4}
            alt="Product"
            className="mx-auto h-80 py-4 rounded-xl mb-4"
          />
          <h2 className="text-xl font-semibold">Royal Navy Blue Shirt</h2>
          <p className="text-gray-600">Color : Blue</p>
          <p className="text-gray-600">Size : M</p>
        </div>

        {/* Refund Credited Banner */}
        <div className="bg-rose-300 flex gap-2 border-l-4 mx-5 border-red-500 text-black p-4 mt-6 rounded-md">
          <svg
            width="51"
            height="50"
            viewBox="0 0 51 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.0302734"
              y="0.585693"
              width="50.1365"
              height="50.1365"
              rx="25.0682"
              fill="#EA4B4B"
            />
            <mask
              id="mask0_1395_16377"
              maskUnits="userSpaceOnUse"
              x="9"
              y="9"
              width="32"
              height="33"
            >
              <rect
                x="9.05371"
                y="9.61108"
                width="31.7765"
                height="31.7765"
                fill="#D9D9D9"
              />
            </mask>
            <g mask="url(#mask0_1395_16377)">
              <path
                d="M24.9435 32.6816L15.6754 23.4134V29.4708H13.0273V18.8787H23.6195V21.5267H17.529L24.9435 28.9412L35.0061 18.8787L36.8597 20.7654L24.9435 32.6816Z"
                fill="white"
              />
            </g>
          </svg>

          <p>
            <strong>Refund Credited</strong> <br />
            You refund of ₹ 2,040.00 for the return has been processed
            successfully on 12 May.
          </p>
        </div>

        {/* Refund Detail Section */}
        <div className="mt-8 mx-5">
          <h3 className="font-semibold text-lg mb-2">Refund Detail</h3>

          <div className="bg-gray-100 rounded-xl p-4 mb-4">
            <div className="flex justify-between text-lg font-semibold">
              <span>Total Refund Amount</span>
              <span>₹ 2145</span>
            </div>
          </div>

          <div className="flex justify-between items-center bg-white border rounded-xl p-4 shadow-sm">
            <div>
              <p className="text-xl font-semibold">₹ 2145</p>
              <p className="text-gray-500 text-sm">Added to UPI</p>
              <p className="text-gray-400 text-sm">Credit by Thu, 1 May</p>
            </div>
            <img
              loading="lazy"
              src="https://upload.wikimedia.org/wikipedia/commons/0/0c/UPI-Logo-vector.svg"
              alt="UPI"
              className="w-14 h-14"
            />
          </div>

          <p className="text-sm text-gray-400 mt-2">
            Have a dispute? Contact your bank with the refund transaction
            reference number: <strong>123456789874</strong>
          </p>
        </div>

        {/* Rating Section */}
        <div className="mt-10 text-center">
          <div className="flex items-center justify-center gap-2 mb-2">
            <img
              loading="lazy"
              src="https://cdn-icons-png.flaticon.com/512/5231/5231019.png"
              alt="rating"
              className="w-6 h-6"
            />
            <p className="text-md font-semibold">
              Rate Your return Pickup Experience
            </p>
          </div>
          <p className="text-gray-500 mb-4 text-sm">
            How would you rate your experience with this order?
          </p>

          <div className="flex justify-center gap-4">
            {[1, 2, 3, 4, 5].map((num) => (
              <button
                key={num}
                className="w-10 h-10 rounded-full border-2 border-gray-400 hover:border-purple-500 text-gray-600 hover:text-purple-600"
              >
                {num}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
